import React, { PropsWithChildren } from 'react'
import { Link } from 'react-router-dom'
import { RoutesEnum } from '../model/enums/RoutesEnum'
import { Button } from './ui/button'
import { SquareArrowOutUpRightIcon } from 'lucide-react'
import { useProject } from '../model/hooks/useProject'

interface Props extends PropsWithChildren {
  label?: string
  targetForm?: string
}

export const AccompanyingReportInputsPreview: React.FC<Props> = ({
  label = 'Údaje z průvodní zprávy',
  targetForm = RoutesEnum.ACCOMPANYING_REPORT,
  children,
}) => {
  const { id: projectId } = useProject()

  return (
    <div className="flex flex-col gap-6 p-4 rounded-md bg-gray-50  border-gray-300 border border-dashed">
      <span className="uppercase text-sm text-gray-500 font-bold">{label}</span>
      {children}
      <div className="flex justify-end">
        <Link to={`${RoutesEnum.PROJECTS}/${projectId}/${targetForm}`}>
          <Button type="button" variant="secondary">
            Upravit
            <SquareArrowOutUpRightIcon className="text-gray-700 w-4 ml-1" />
          </Button>
        </Link>
      </div>
    </div>
  )
}
